import {
  GOOGLE_ADS_CAMPAIGN_STATUS,
  GoogleAdsCampaignConnectionStatus,
} from '../../../../../../services/exports/Constants';

export default {
  title: 'Google Ads',
  search: {
    placeholder: 'Zoeken op ID, naam of bedrijf',
  },
  filters: {
    connection_statuses: {
      placeholder: 'Verbindingsstatus',
      options: {
        [GoogleAdsCampaignConnectionStatus.Connected]: 'Verbonden',
        [GoogleAdsCampaignConnectionStatus.NotConnected]: 'Niet verbonden',
      },
    },
  },
  columns: {
    name: 'Naam',
    company: 'Bedrijf',
    connected: 'Verbonden',
    action: 'Actie',
    details: 'Details',
    address: 'Adres',
    status: 'Status',
  },
  status: {
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNSPECIFIED]: 'Niet opgegeven',
    [GOOGLE_ADS_CAMPAIGN_STATUS.ENABLED]: 'Actief',
    [GOOGLE_ADS_CAMPAIGN_STATUS.PAUSED]: 'Gepauzeerd',
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNKNOWN]: 'Onbekend',
    [GOOGLE_ADS_CAMPAIGN_STATUS.REMOVED]: 'Verwijderd',
  },
};
